import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      className="icon-facebook"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 17"
    >
      <g>
        <g className="cls-2">
          <path
            className="cls-3"
            d="M16,8.58A7.12,7.12,0,0,1,8.9,15.7l-.48,0A7.12,7.12,0,1,1,16,8.58"
          />
          <path
            className="cls-4"
            d="M10.57,7.27c0,.44,0,1.46,0,1.46h2c-.1.71-.19,1.39-.28,2.07H10.57v4.7a7.13,7.13,0,0,1-1.67.2l-.48,0V10.79H6.67V8.73H8.43V8.58c0-.42,0-.83,0-1.24a5.29,5.29,0,0,1,.07-.8A2.32,2.32,0,0,1,9.42,5,2.75,2.75,0,0,1,11,4.53c.36,0,.72,0,1.09,0,.2,0,.4,0,.58.06V6.45H12.5c-.36,0-.71,0-1.07,0s-.84.2-.86.81"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
